







































import Vue from 'vue';
import VueTagsInput from '@johmun/vue-tags-input';
import { mapState } from 'vuex';
import pxButton from '@/dex-shared/components/px-button.vue';

export default Vue.extend({
  components: {
    pxButton,
    VueTagsInput,
  },
  props: {
    type: {
      type: String,
      default: 'question',
      validator: (val: string) => ['question', 'article'].includes(val),
    },
    id: {
      type: Number,
      default: null,
    },
    creating: Boolean,
    maxTags: {
      type: Number,
      default: Infinity,
    },
    allowParentTags: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedId: '',
      tag: '',
    };
  },
  computed: {
    ...mapState({
      knowledgeTags: (state: any) => state.treeKnowledges.knowledges,
      childrenNodesWithoutGrandChildren: (state: any) =>
        state.treeKnowledges.childrenNodesWithoutGrandChildren,
      childrenNodesWithGrandChildren: (state: any) =>
        state.treeKnowledges.childrenNodesWithGrandChildren,
      childrenNodes: (state: any) => state.treeKnowledges.childrenNodes,
      parentNode: (state: any) => state.treeKnowledges.parentNode,
    }),
    filteredItems() {
      return (this.allowParentTags
        ? this.childrenNodes
        : this.childrenNodesWithoutGrandChildren
      ).filter(i => {
        return (
          this.normalizeStr(i.text).indexOf(this.normalizeStr(this.tag)) !== -1
        );
      });
    },
  },
  watch: {
    selectedId: {
      handler: async function(val) {
        if (val) {
          await Promise.all([
            this.$store.dispatch('PULL_NODE', val),
            this.$store.dispatch('PULL_CHILDREN_NODES', val),
          ]);
        } else {
          await this.$store.dispatch('PULL_ROOT_NODES');
        }
      },
    },
  },
  async created() {
    this.$store.commit('CLEAN_KNOWLEDGES');
    await this.$store.dispatch('PULL_ROOT_NODES');
    if (this.id && !this.creating) {
      await this.$store.dispatch('PULL_KNOWLEDGE_ASSOCIATIONS', {
        type: this.type,
        id: this.id,
      });
    }
  },
  methods: {
    normalizeStr(str: string) {
      return str
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    },
    goBack() {
      this.selectedId = this.parentNode.parentId
        ? this.parentNode.parentId
        : '';
    },
    insertKnowledge: function(newTags: any) {
      this.$store.commit('SET_KNOWLEDGES', newTags);
    },
  },
});
